module.exports = __webpack_public_path__ + "img/HandsTogether.59ba4856.jpg";